var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 103,
    viewBox: "0 0 100 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4229 35.0712H13.4784C10.6789 35.0712 7.99405 36.2123 6.0145 38.2435C4.03495 40.2746 2.92285 43.0295 2.92285 45.9021V67.5639C2.92285 70.4364 4.03495 73.1913 6.0145 75.2225C7.99405 77.2537 10.6789 78.3948 13.4784 78.3948H29.3117M50.4229 67.5639H87.3673C90.1668 67.5639 92.8516 66.4228 94.8312 64.3916C96.8107 62.3604 97.9228 59.6055 97.9228 56.733V35.0712C97.9228 32.1986 96.8107 29.4437 94.8312 27.4125C92.8516 25.3813 90.1668 24.2402 87.3673 24.2402H71.534",
    stroke: "#EBEBEB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3118 35.0709V13.409C29.3118 10.5365 30.4239 7.78162 32.4034 5.75043C34.383 3.71924 37.0678 2.57813 39.8673 2.57812H60.9784C63.7779 2.57813 66.4628 3.71924 68.4423 5.75043C70.4219 7.78162 71.534 10.5365 71.534 13.409V40.4863C71.534 43.3589 70.4219 46.1138 68.4423 48.145C66.4628 50.1761 63.7779 51.3173 60.9784 51.3173H39.8673C37.0678 51.3173 34.383 52.4584 32.4034 54.4896C30.4239 56.5208 29.3118 59.2756 29.3118 62.1482V89.2255C29.3118 92.098 30.4239 94.8529 32.4034 96.8841C34.383 98.9153 37.0678 100.056 39.8673 100.056H60.9784C63.7779 100.056 66.4628 98.9153 68.4423 96.8841C70.4219 94.8529 71.534 92.098 71.534 89.2255V67.5636M45.1451 18.8245V18.8787M55.7007 83.81V83.8642",
    stroke: "#EBEBEB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory10);
export default __webpack_public_path__ + "static/media/category-10.fa8676e7bb15478aaca1f688e55b6b14.svg";
export { ForwardRef as ReactComponent };